import clsx from 'clsx'
import map from 'lodash/map'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

const StyledLanguageToggle = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.greyLightest};
  border-bottom: 1px solid #ddd;
  padding: 20px 20px 20px;
`

const StyledToggleText = styled.span`
  margin-right: 10px;
`

const StyledOptions = styled.div`
  display: flex;

  & > a {
    padding: 2px 5px;
    background-color: ${({ theme }) => theme.colors.grey};
    color: #fff;
    opacity: 0.5;
    cursor: pointer;

    &:first-child {
      border-right: none;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.greyDark};
      opacity: 0.75;
    }

    &.is-active {
      background-color: ${({ theme }) => theme.colors.greyDark};
      color: #fff;
      opacity: 1;
    }
  }
`

export const LanguageToggle = () => {
  const { t } = useTranslation()
  const { availableLocales, store } = useContext(MetadataContext)

  if (!availableLocales || availableLocales.length < 2) {
    return null
  }

  return (
    <StyledLanguageToggle>
      <StyledToggleText>{t('header:SIDE_BAR_LANG_SELECT_TITLE')}</StyledToggleText>
      <StyledOptions>
        {map(availableLocales, ({ localeCode, title, url }) => (
          <a
            key={title}
            className={clsx(
              store?.config?.localeCode === localeCode && 'is-active',
            )}
            href={url}
          >
            {title}
          </a>
        ))}
      </StyledOptions>
    </StyledLanguageToggle>
  )
}
